<!-- 状态面板 -->
<template>
    <div>
        <div class="card">
            <div class="title">{{ newFormData.name }}</div>
        </div>
        <div class="card mb0">
            <Menu
                mode="horizontal"
                :active-name="name_id"
                @on-select="selectName"
            >
                <MenuItem name="1" class="head-text">内容设置</MenuItem>
                <MenuItem name="2" class="head-text">样式设置</MenuItem>
                <MenuItem name="3" class="head-text">边距设置</MenuItem>
            </Menu>
            <div class="mt24 mb24">
                <!-- 内容设置 -->
                <div v-if="name_id == 1">
                    <div class="form-title">状态面板</div>
                    <div class="section-label">添加状态</div>
                    <div class="status-list-box">
                        <div
                            class="status-item"
                            v-for="(item, index) in newFormData.content
                                .statusList"
                            :key="index"
                        >
                            <div class="item-actions">
                                <span
                                    class="action-link"
                                    @click="moveStatus(index, -1)"
                                    >上移</span
                                >
                                <span
                                    class="action-link"
                                    @click="moveStatus(index, 1)"
                                    >下移</span
                                >
                                <span
                                    class="action-link"
                                    @click="openStatusEdit(index)"
                                    >编辑</span
                                >
                                <div
                                    class="del-btn"
                                    @click="delStatus(index)"
                                >
                                    <Icon type="ios-trash" color="#fff" />
                                </div>
                            </div>
                            <Form
                                :label-width="110"
                                label-position="left"
                            >
                                <FormItem label="状态标题">
                                    <Input
                                        v-model="item.title"
                                        placeholder="请输入状态标题"
                                    />
                                    <!-- <div class="tip-red">
                                        默认文字：{{
                                            item.default_title || "状态"
                                        }}
                                    </div> -->
                                </FormItem>
                                <FormItem label="当前状态">
                                    <RadioGroup v-model="item.current_status">
                                        <Radio
                                            class="mr24"
                                            v-for="(opt, oi) in item.statusOptions"
                                            :key="oi"
                                            :label="opt.name"
                                            >{{ opt.name }}</Radio
                                        >
                                    </RadioGroup>
                                </FormItem>
                                <FormItem label="更新权限">
                                    <span>{{
                                        permissionText(item.permission)
                                    }}</span>
                                    <span
                                        class="action-link ml12"
                                        @click="openPermission(index)"
                                        >修改</span
                                    >
                                </FormItem>
                                <FormItem label="自动变更规则">
                                    <span
                                        >{{
                                            (item.rules && item.rules.length) ||
                                            0
                                        }}
                                        条</span
                                    >
                                    <span
                                        class="action-link ml12"
                                        @click="openRules(index)"
                                        >修改</span
                                    >
                                </FormItem>
                            </Form>
                        </div>
                        <div class="add-status" @click="addStatus">
                            <Icon type="md-add" size="20" color="#FF761D" />
                            <span>添加状态项</span>
                        </div>
                    </div>
                </div>

                <!-- 样式设置 -->
                <div v-if="name_id == 2">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="100"
                    >
                        <div class="form-title">选择样式</div>
                        <div class="style-select">
                            <div
                                :class="
                                    newFormData.content.style_value == '1'
                                        ? 'style-card style-card-active'
                                        : 'style-card'
                                "
                                @click="changeStyle('1')"
                            >
                                <div class="preview-single">
                                    <div class="preview-title">状态标题</div>
                                    <div class="preview-value">正常</div>
                                    <div class="preview-time">
                                        2月12日 12:23 更新
                                    </div>
                                </div>
                            </div>
                            <div
                                :class="
                                    newFormData.content.style_value == '2'
                                        ? 'style-card style-card-active'
                                        : 'style-card'
                                "
                                @click="changeStyle('2')"
                            >
                                <div class="preview-double">
                                    <div class="preview-half">
                                        <div class="preview-title">
                                            状态标题
                                        </div>
                                        <div class="preview-value sm">
                                            正常
                                        </div>
                                        <div class="preview-time">
                                            2月12日 12:23 更新
                                        </div>
                                    </div>
                                    <div class="preview-half">
                                        <div class="preview-title">
                                            状态标题
                                        </div>
                                        <div class="preview-value sm">
                                            正常
                                        </div>
                                        <div class="preview-time">
                                            2月12日 12:23 更新
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-title">背景设置</div>
                        <FormItem label="背景颜色">
                            <ColorPicker
                                v-model="newFormData.content.bg_color"
                            />
                        </FormItem>
                        <FormItem label="背景图">
                            <i-switch
                                v-model="newFormData.content.bg_value"
                                size="large"
                                true-color="#FF761D "
                                :true-value="1"
                                :false-value="0"
                                @on-change="changeBgValue"
                            >
                                <span slot="open">开启</span>
                                <span slot="close">关闭</span>
                            </i-switch>
                        </FormItem>
                        <FormItem
                            v-if="newFormData.content.bg_value"
                            label="上传背景"
                        >
                            <div class="bg-upload" @click="openPicModal">
                                <img
                                    class="bg-img"
                                    v-if="newFormData.content.bg_img.picview"
                                    :src="newFormData.content.bg_img.picview"
                                />
                                <Icon
                                    v-else
                                    type="md-add"
                                    size="30"
                                    color="#ccc"
                                />
                            </div>
                        </FormItem>
                    </Form>
                </div>

                <!-- 边距设置 -->
                <div v-if="name_id == 3">
                    <Form
                        :model="newFormData"
                        label-position="right"
                        :label-width="80"
                    >
                        <div class="form-title">外间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.marginData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.marginData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">内间距</div>
                        <FormItem label="上下间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="左右间距"
                            ><Slider
                                v-if="newFormData.content.paddingData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.paddingData.left"
                            ></Slider
                        ></FormItem>
                        <div class="form-title">圆角设置</div>
                        <FormItem label="上圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.top"
                            ></Slider
                        ></FormItem>
                        <FormItem label="下圆角"
                            ><Slider
                                v-if="newFormData.content.radiusData"
                                class="w300"
                                show-input
                                v-model="newFormData.content.radiusData.bottom"
                            ></Slider
                        ></FormItem>
                    </Form>
                </div>
            </div>
        </div>

        <!-- 编辑状态项弹窗 -->
        <Modal
            v-model="statusModal"
            title="状态"
            :width="640"
            :mask-closable="false"
        >
            <div class="modal-row mb16">
                <span class="modal-label">
                    状态
                    <Icon type="md-create" />
                </span>
                <Input
                    class="flex1"
                    v-model="editTitle"
                    placeholder="请输入状态名"
                />
                <Button
                    class="theme-bc theme-default-color ml12"
                    @click="confirmEditTitle"
                    >确认</Button
                >
            </div>
            <div class="section-label mb12">状态项</div>
            <div
                class="opt-row"
                v-for="(opt, oi) in editOptions"
                :key="oi"
            >
                <Select class="w120" v-model="opt.name" filterable>
                    <Option
                        v-for="p in presetStatus"
                        :value="p"
                        :key="p"
                        >{{ p }}</Option
                    >
                </Select>
                <Checkbox
                    class="ml12"
                    v-model="opt.is_default"
                    @on-change="(v) => setDefaultOption(oi, v)"
                    >默认状态</Checkbox
                >
                <span class="opt-req">{{ requireText(opt) }}</span>
                <span
                    class="action-link ml8"
                    @click="openRequire(oi)"
                    >修改</span
                >
                <Icon
                    class="ml8 cursor-p"
                    type="ios-close-circle"
                    color="#ed4014"
                    size="20"
                    @click="delOption(oi)"
                />
            </div>
            <div class="add-status mt12" @click="addOption">
                <Icon type="md-add" size="18" color="#FF761D" />
                <span>添加状态项</span>
            </div>
            <div slot="footer">
                <Button @click="statusModal = false">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="saveStatusEdit"
                    >确定</Button
                >
            </div>
        </Modal>

        <!-- 设置切换要求 -->
        <Modal
            v-model="requireModal"
            title="设置切换要求"
            :width="520"
            :mask-closable="false"
        >
            <div class="mb16">
                设置切换到「{{
                    (editOptions[requireIndex] &&
                        editOptions[requireIndex].name) ||
                    ""
                }}」时的要求
            </div>
            <RadioGroup v-model="requireForm.require_type" vertical>
                <Radio label="none" class="mb12">无任何要求</Radio>
                <Radio label="desc">需填写描述信息</Radio>
            </RadioGroup>
            <div
                class="require-box"
                v-if="requireForm.require_type == 'desc'"
            >
                <div class="mb12">
                    <span class="mr12">支持类型</span>
                    <CheckboxGroup v-model="requireForm.support_types">
                        <Checkbox label="text">文字描述</Checkbox>
                        <Checkbox label="image">图片</Checkbox>
                        <Checkbox label="location">定位</Checkbox>
                    </CheckboxGroup>
                </div>
                <div>
                    <span class="mr12">是否必填</span>
                    <RadioGroup v-model="requireForm.is_required">
                        <Radio :label="1">必填</Radio>
                        <Radio :label="0">不必填</Radio>
                    </RadioGroup>
                </div>
            </div>
            <div slot="footer">
                <Button @click="requireModal = false">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="saveRequire"
                    >确定</Button
                >
            </div>
        </Modal>

        <!-- 更新权限 -->
        <Modal
            v-model="permissionModal"
            title="更新权限"
            :width="560"
            :mask-closable="false"
        >
            <RadioGroup v-model="permissionForm.type" vertical>
                <Radio label="everyone" class="mb8">所有人</Radio>
                <div class="perm-tip" v-if="permissionForm.type == 'everyone'">
                    允许所有被记录拥有人可写，请确保合法合规
                </div>
                <Radio label="member" class="mt12 mb8">指定成员</Radio>
            </RadioGroup>
            <div
                class="require-box"
                v-if="permissionForm.type == 'member'"
            >
                <RadioGroup v-model="permissionForm.member_type">
                    <Radio label="all" class="mr24">全部成员</Radio>
                    <Radio label="specified">指定成员</Radio>
                </RadioGroup>
                <Select
                    class="mt12 w240"
                    v-if="permissionForm.member_type == 'specified'"
                    v-model="permissionForm.members"
                    multiple
                    filterable
                    placeholder="选择人员"
                >
                    <Option
                        v-for="m in memberOptions"
                        :value="m.id"
                        :key="m.id"
                        >{{ m.name }}</Option
                    >
                </Select>
            </div>
            <div class="perm-warn">
                注：所有人无需登录即可更新；全部成员 /
                指定成员需登录且满足条件后可写
            </div>
            <div slot="footer">
                <Button @click="permissionModal = false">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="savePermission"
                    >确定</Button
                >
            </div>
        </Modal>

        <!-- 自动变更规则 -->
        <Modal
            v-model="rulesModal"
            title="自动变更规则"
            :width="640"
            :mask-closable="false"
        >
            <div v-if="!editRules.length" class="rules-empty">
                <div class="empty-tip">暂无规则</div>
                <div class="empty-preview">
                    <div class="empty-card">
                        <div class="preview-title">状态标题</div>
                        <div class="preview-value">正常</div>
                        <div class="preview-time">2月12日 12:23 更新</div>
                    </div>
                    <div class="empty-card">
                        <div class="preview-title">状态标题</div>
                        <div class="preview-value">正常</div>
                        <div class="preview-time">2月12日 12:23 更新</div>
                    </div>
                </div>
                <div class="empty-desc">
                    可配置：当指定表单提交数据时，自动将二维码上的状态变更为目标状态项
                </div>
            </div>
            <div v-else class="rules-list">
                <div
                    class="rule-item"
                    v-for="(rule, ri) in editRules"
                    :key="ri"
                >
                    <div class="rule-text">
                        当【{{ rule.form_name || "表单名称" }}】表单任意数据提交时，二维码上的「{{
                            currentItemTitle
                        }}」变更为「{{ rule.target_status || "状态" }}」
                    </div>
                    <div class="rule-actions">
                        <span
                            class="action-link"
                            @click="openRuleForm(ri)"
                            >修改</span
                        >
                        <span
                            class="action-link ml12"
                            @click="delRule(ri)"
                            >删除</span
                        >
                    </div>
                </div>
            </div>
            <Button
                long
                class="theme-bc theme-default-color mt16"
                @click="openRuleForm(-1)"
                >+ 新增规则</Button
            >
            <div slot="footer">
                <Button @click="rulesModal = false">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="saveRules"
                    >确定</Button
                >
            </div>
        </Modal>

        <!-- 新增/修改规则 -->
        <Modal
            v-model="ruleFormModal"
            title="新增规则"
            :width="520"
            :mask-closable="false"
        >
            <Form :label-width="140" label-position="left">
                <FormItem label="当码上的表单">
                    <Select
                        v-model="ruleForm.form_id"
                        filterable
                        placeholder="请选择表单"
                        @on-change="onFormChange"
                    >
                        <Option
                            v-for="f in formOptions"
                            :value="f.id"
                            :key="f.id"
                            >{{ f.name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="提交的数据类型为">
                    <Input value="任意数据提交时" disabled />
                </FormItem>
                <FormItem label="二维码状态变更为">
                    <Select
                        v-model="ruleForm.target_status"
                        filterable
                        placeholder="请选择状态项"
                    >
                        <Option
                            v-for="(opt, oi) in currentStatusOptions"
                            :value="opt.name"
                            :key="oi"
                            >{{ opt.name }}</Option
                        >
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="ruleFormModal = false">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="saveRuleForm"
                    >确定</Button
                >
            </div>
        </Modal>

        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";

function createDefaultOptions() {
    return [
        {
            name: "正常",
            is_default: true,
            require_type: "none",
            support_types: ["text", "image", "location"],
            is_required: 1,
        },
        {
            name: "异常",
            is_default: false,
            require_type: "none",
            support_types: ["text", "image", "location"],
            is_required: 1,
        },
    ];
}

function createStatusItem() {
    const options = createDefaultOptions();
    return {
        title: "状态",
        default_title: "状态",
        current_status: "正常",
        update_time: "2月12日 12:23 更新",
        statusOptions: options,
        permission: {
            type: "member",
            member_type: "all",
            members: [],
        },
        rules: [],
    };
}

export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
            presetStatus: ["正常", "异常", "待处理", "已完成"],
            memberOptions: [],
            formOptions: [],
            // 编辑状态
            statusModal: false,
            editIndex: -1,
            editTitle: "",
            editOptions: [],
            // 切换要求
            requireModal: false,
            requireIndex: -1,
            requireForm: {
                require_type: "none",
                support_types: [],
                is_required: 1,
            },
            // 权限
            permissionModal: false,
            permissionForm: {
                type: "everyone",
                member_type: "all",
                members: [],
            },
            // 规则
            rulesModal: false,
            editRules: [],
            ruleFormModal: false,
            ruleEditIndex: -1,
            ruleForm: {
                form_id: "",
                form_name: "",
                target_status: "",
            },
        };
    },
    computed: {
        currentItemTitle() {
            const list = this.newFormData.content.statusList || [];
            const item = list[this.editIndex];
            return (item && item.title) || "状态标题";
        },
        currentStatusOptions() {
            const list = this.newFormData.content.statusList || [];
            const item = list[this.editIndex];
            return (item && item.statusOptions) || [];
        },
    },
    methods: {
        selectName(name) {
            this.name_id = name;
        },
        changeStyle(val) {
            this.newFormData.content.style_value = val;
        },
        changeBgValue(e) {
            this.newFormData.content.bg_value = e;
        },
        openPicModal() {
            this.switch_modal = true;
        },
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.bg_img.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.bg_img.value = param2[i];
            }
            this.$Message.destroy();
        },
        ensureStatusList() {
            if (!this.newFormData.content.statusList) {
                this.$set(this.newFormData.content, "statusList", [
                    createStatusItem(),
                    createStatusItem(),
                ]);
            }
        },
        addStatus() {
            this.ensureStatusList();
            this.newFormData.content.statusList.push(createStatusItem());
        },
        delStatus(index) {
            const list = this.newFormData.content.statusList;
            if (list.length <= 1) {
                this.$Message.warning("至少保留一个状态项");
                return;
            }
            list.splice(index, 1);
        },
        moveStatus(index, step) {
            const list = this.newFormData.content.statusList;
            const target = index + step;
            if (target < 0 || target >= list.length) return;
            const temp = list[index];
            this.$set(list, index, list[target]);
            this.$set(list, target, temp);
        },
        permissionText(permission) {
            if (!permission) return "所有成员";
            if (permission.type === "everyone") return "所有人";
            if (permission.member_type === "specified") return "指定成员";
            return "所有成员";
        },
        requireText(opt) {
            if (!opt || opt.require_type === "none") return "无任何要求";
            return "需填写描述信息";
        },
        // —— 编辑状态项 ——
        openStatusEdit(index) {
            this.ensureStatusList();
            const item = this.newFormData.content.statusList[index];
            this.editIndex = index;
            this.editTitle = item.title || "";
            this.editOptions = JSON.parse(
                JSON.stringify(item.statusOptions || createDefaultOptions())
            );
            this.statusModal = true;
        },
        confirmEditTitle() {
            if (!this.editTitle.trim()) {
                this.$Message.warning("请输入状态名");
                return;
            }
            this.$Message.success("已确认");
        },
        setDefaultOption(oi, checked) {
            this.editOptions.forEach((opt, i) => {
                opt.is_default = i === oi ? !!checked : false;
            });
        },
        addOption() {
            this.editOptions.push({
                name: "正常",
                is_default: false,
                require_type: "none",
                support_types: ["text", "image", "location"],
                is_required: 1,
            });
        },
        delOption(oi) {
            if (this.editOptions.length <= 1) {
                this.$Message.warning("至少保留一个状态项");
                return;
            }
            const wasDefault = this.editOptions[oi].is_default;
            this.editOptions.splice(oi, 1);
            if (wasDefault && this.editOptions.length) {
                this.editOptions[0].is_default = true;
            }
        },
        saveStatusEdit() {
            if (!this.editTitle.trim()) {
                this.$Message.warning("请输入状态名");
                return;
            }
            if (!this.editOptions.length) {
                this.$Message.warning("请至少添加一个状态项");
                return;
            }
            const item = this.newFormData.content.statusList[this.editIndex];
            item.title = this.editTitle.trim();
            item.statusOptions = JSON.parse(JSON.stringify(this.editOptions));
            const names = item.statusOptions.map((o) => o.name);
            if (!names.includes(item.current_status)) {
                const def = item.statusOptions.find((o) => o.is_default);
                item.current_status = (def && def.name) || names[0];
            }
            this.statusModal = false;
        },
        // —— 切换要求 ——
        openRequire(oi) {
            const opt = this.editOptions[oi];
            this.requireIndex = oi;
            this.requireForm = {
                require_type: opt.require_type || "none",
                support_types: [...(opt.support_types || [])],
                is_required: opt.is_required == null ? 1 : opt.is_required,
            };
            this.requireModal = true;
        },
        saveRequire() {
            const opt = this.editOptions[this.requireIndex];
            opt.require_type = this.requireForm.require_type;
            opt.support_types = [...this.requireForm.support_types];
            opt.is_required = this.requireForm.is_required;
            this.requireModal = false;
        },
        // —— 更新权限 ——
        openPermission(index) {
            this.ensureStatusList();
            this.editIndex = index;
            const p =
                this.newFormData.content.statusList[index].permission || {};
            this.permissionForm = {
                type: p.type || "everyone",
                member_type: p.member_type || "all",
                members: [...(p.members || [])],
            };
            this.permissionModal = true;
        },
        savePermission() {
            const item = this.newFormData.content.statusList[this.editIndex];
            item.permission = {
                type: this.permissionForm.type,
                member_type: this.permissionForm.member_type,
                members: [...this.permissionForm.members],
            };
            this.permissionModal = false;
        },
        // —— 自动变更规则 ——
        openRules(index) {
            this.ensureStatusList();
            this.editIndex = index;
            const item = this.newFormData.content.statusList[index];
            this.editRules = JSON.parse(JSON.stringify(item.rules || []));
            this.rulesModal = true;
        },
        saveRules() {
            const item = this.newFormData.content.statusList[this.editIndex];
            item.rules = JSON.parse(JSON.stringify(this.editRules));
            this.rulesModal = false;
        },
        delRule(ri) {
            this.editRules.splice(ri, 1);
        },
        openRuleForm(ri) {
            this.ruleEditIndex = ri;
            if (ri === -1) {
                this.ruleForm = {
                    form_id: "",
                    form_name: "",
                    target_status: "",
                };
            } else {
                const rule = this.editRules[ri];
                this.ruleForm = {
                    form_id: rule.form_id,
                    form_name: rule.form_name,
                    target_status: rule.target_status,
                };
            }
            this.ruleFormModal = true;
        },
        onFormChange(id) {
            const form = this.formOptions.find((f) => f.id === id);
            this.ruleForm.form_name = form ? form.name : "";
        },
        saveRuleForm() {
            if (!this.ruleForm.form_id) {
                this.$Message.warning("请选择表单");
                return;
            }
            if (!this.ruleForm.target_status) {
                this.$Message.warning("请选择状态项");
                return;
            }
            const data = {
                form_id: this.ruleForm.form_id,
                form_name: this.ruleForm.form_name,
                target_status: this.ruleForm.target_status,
            };
            if (this.ruleEditIndex === -1) {
                this.editRules.push(data);
            } else {
                this.$set(this.editRules, this.ruleEditIndex, data);
            }
            this.ruleFormModal = false;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-title {
    margin: 24px 0 12px;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
.section-label {
    margin-bottom: 8px;
    font-size: 14px;
    color: #666;
}
.status-list-box {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 12px;
    background: #fff;
}
.status-item {
    position: relative;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 12px 12px 4px;
    margin-bottom: 12px;
    background: #fafafa;
}
.item-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 8px;
}
.action-link {
    color: #ff761d;
    cursor: pointer;
    margin-left: 12px;
    font-size: 13px;
}
.ml8 {
    margin-left: 8px;
}
.ml12 {
    margin-left: 12px;
}
.mr12 {
    margin-right: 12px;
}
.mb8 {
    margin-bottom: 8px;
}
.mb12 {
    margin-bottom: 12px;
}
.mb16 {
    margin-bottom: 16px;
}
.mt12 {
    margin-top: 12px;
}
.mt16 {
    margin-top: 16px;
}
.del-btn {
    margin-left: 12px;
    width: 28px;
    height: 28px;
    background: #ff761d;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.tip-red {
    margin-top: 4px;
    font-size: 12px;
    color: #ed4014;
}
.add-status {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    color: #ff761d;
    cursor: pointer;
    font-size: 14px;
}
.add-status span {
    margin-left: 4px;
}
.style-select {
    display: flex;
    gap: 16px;
    margin-bottom: 12px;
}
.style-card {
    flex: 1;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 10px;
    cursor: pointer;
    background: #fff;
}
.style-card-active {
    border-color: #ff761d;
    box-shadow: 0 0 0 1px #ff761d;
}
.preview-single {
    padding: 8px;
}
.preview-double {
    display: flex;
}
.preview-half {
    flex: 1;
    padding: 6px;
}
.preview-half + .preview-half {
    border-left: 1px solid #eee;
}
.preview-title {
    font-size: 12px;
    color: #333;
    font-weight: 500;
}
.preview-value {
    margin: 8px 0;
    font-size: 22px;
    font-weight: 700;
    color: #52c41a;
}
.preview-value.sm {
    font-size: 16px;
}
.preview-time {
    font-size: 11px;
    color: #999;
}
.bg-upload {
    width: 80px;
    height: 80px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.bg-img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
}
.modal-row {
    display: flex;
    align-items: center;
}
.modal-label {
    margin-right: 12px;
    white-space: nowrap;
    color: #484e66;
}
.flex1 {
    flex: 1;
}
.opt-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    padding: 8px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
}
.opt-req {
    margin-left: auto;
    color: #666;
    font-size: 13px;
}
.w120 {
    width: 120px;
}
.w240 {
    width: 240px;
}
.cursor-p {
    cursor: pointer;
}
.require-box {
    margin: 12px 0 0 24px;
    padding: 12px;
    background: #fafafa;
    border-radius: 4px;
}
.perm-tip {
    margin: 4px 0 0 24px;
    color: #999;
    font-size: 12px;
}
.perm-warn {
    margin-top: 16px;
    color: #ed4014;
    font-size: 12px;
    line-height: 1.6;
}
.rules-empty {
    text-align: center;
    padding: 12px 0 8px;
}
.empty-tip {
    color: #999;
    margin-bottom: 16px;
}
.empty-preview {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-bottom: 12px;
}
.empty-card {
    width: 160px;
    padding: 12px;
    border: 1px solid #eee;
    border-radius: 4px;
    text-align: left;
    background: #fff;
}
.empty-desc {
    color: #999;
    font-size: 12px;
    line-height: 1.6;
}
.rule-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 12px;
    margin-bottom: 8px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background: #fafafa;
}
.rule-text {
    flex: 1;
    color: #484e66;
    font-size: 13px;
    line-height: 1.6;
    padding-right: 12px;
}
.rule-actions {
    white-space: nowrap;
}
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: #ff761d;
}
::v-deep .ivu-radio-inner:after {
    background-color: #ff761d;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
::v-deep .ivu-menu-horizontal .ivu-menu-item-active,
::v-deep .ivu-menu-horizontal .ivu-menu-item:hover,
::v-deep .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active {
    color: #ff761d;
    border-bottom-color: #ff761d;
}
::v-deep .ivu-slider-bar {
    background-color: #ff761d;
}
::v-deep .ivu-slider-button {
    border: 2px solid #ff761d;
}
</style>
